import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { UserPermissionsMain } from './components/UserPermissionsMain'
import { UserPermissionsProvider } from './context/UserPermissionsProvider'
import { UserPermissionsWorkflowsProvider } from './context/UserPermissionsWorkflowsProvider'
import { CreateUserPermissionsFlow } from './workflows/CreateUserPermissionsFlow'
import { RemoveUserPermissionsFlow } from './workflows/RemoveUserPermissionsFlow'
import { AuthorizeAdminFlow } from './workflows/AuthorizeAdminFlow'

export const UserPermissions = () => {
  return (
    <NuqsAdapter>
      <UserPermissionsProvider>
        <UserPermissionsWorkflowsProvider>
          <UserPermissionsMain />
          <CreateUserPermissionsFlow />
          <AuthorizeAdminFlow />
          <RemoveUserPermissionsFlow />
        </UserPermissionsWorkflowsProvider>
      </UserPermissionsProvider>
    </NuqsAdapter>
  )
}
